export const practices = [
  {
    name: 'Discomfort',
    description: [
      `Uncomfortable conversations are a fact of organisational life. High performing teams have those conversations well.`,
      `The Discomfort practice is composed of your team's capacity for discomfort, and your own capacity.`
    ],
    subpractices: [
      { title: `This team's`, description: `High performing teams have a high capacity for being productive when uncomfortable. They have developed the fitness for staying in uncomfortable conversations long enough to resolve them.` },
      { title: `Mine in this team`, description: `High performing teams have a roughly symmetric capacity for discomfort, with some slightly leading others so as to continually drive the group to improve. Like a high performing running, skiing or cycling group.` }
    ]
  },
  {
    name: 'Social Risk',
    description: [
      `This practice measures your team's ability to take risks together.  It's sometimes called "psychological safety".`,
      <>Social Risk in group dynamics comes in two types: <i>Disclosive</i> risks and <i>Conflicting</i> risks.</>
    ],
    subpractices: [
      { title: `Disclosive`, description: `High performing teams take disclosive (sharing) risks with each other. Team members have learned that they can share what they think and feel - even when unflattering or unconventional - and still maintain their relationship with the group.` },
      { title: `Conflicting`, description: `High performing teams take conflicting (disagree/debate) risks with each other. Team members have learned that they can disagree, debate and conflict - constructively - and find that this not just survivable, it's actually generative.` }
    ]
  },
  {
    name: 'Accountability',
    description: [
      `High performing teams set expectations of each other and then hold team members to account.`,
      `Accountability includes the ability to set common expectations together, and also to comment constructively on each others work.`
    ],
    subpractices: [
      { title: `No fences`, description: `High performing teams have no "fences", they respectfully understand, interrogate, question, and challenge each other's domains. They don't just "stay in their lanes".` },
      { title: `Shared expectations`, description: `High performing teams set behavioral and performance expectations for membership and standing within the team, and then hold each other to account for those expectations.` }
    ]
  },
  {
    name: 'Interpersonal',
    description: [
      `Teams are built on the connections between team members. High performing teams have strong links.`,
      `Interpersonal dynamics includes how well we understand each other's contexts, and also how well our conversation utilizes our various team members.`
    ],
    subpractices: [
      { title: `Who speaks`, description: `High performing teams move rapidly to fully networked discourse and stay there. Any time they spend in monologues, or in dialogues that exclude some members, is deliberate, constructive, and minimal.` },
      { title: `Professional intimacy`, description: `High performing teams know how each member shows up to that team. Each team member knows about the personal and work contextual factors that might affect how their colleagues show up to the team, or to their work.` }
    ]
  },
  {
    name: 'Course Correct',
    description: [
      `High performing teams can course correct in close to real time.`,
      <>Course Correction means they can <i>Sense</i> what is and isn&apos;t working in the team and then <i>Act</i> to change as required.</>
    ],
    subpractices: [
      { title: `Sense`, description: `High performing teams can talk about the team's performance in real time. They notice what is happening in the team dynamic, they can call attention to what is happening, and then discuss its impact and whether or not it needs to change.` },
      { title: `Act`, description: `High performing teams can correct the team's performance in real time. They can turn discussions about how the team is performing into actioned change.` }
    ]
  },
  {
    name: 'Sensemaking',
    description: [
      `High performing teams use the team as a basis for continually updating their understanding of the world around them.`,
      `Sensemaking includes being open to - and able to - change minds in the team environment, and also constantly comparing and updating consensus narratives.`
    ],
    subpractices: [
      { title: `Updating individual understanding`, description: `High performing teams have team members who regularly update their sensemaking as their world changes. They are open to changing their minds in the team, and they are capable of changing their colleagues' minds.` },
      { title: `Co-creating sensemaking`, description: `High performing teams constantly create shared narratives of what is happening in their world, both to help them with consensus understand, and also to help the sensemaking of those outside the team.` }
    ]
  }
]
